/*  ========================================================================
    # Components - Sections - Checklist
    ========================================================================  */

// Dependencies
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';

// Assets
import CheckWithCircle from '@images/svg/ui/check-with-circle.svg';
import ChevronLeft from '@images/svg/ui/chevron-left.svg';
import ChevronRight from '@images/svg/ui/chevron-right.svg';
import ChevronThiccRight from '@images/svg/ui/chevron-thicc-right.svg';

const Checklist = () => {
  const shifterRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [shifterTranslateX, setSliderTranslateX] = useState(null);

  const adjustSlider = useCallback(() => {
    const shifterRect = shifterRef.current.getBoundingClientRect();
    setSliderTranslateX({
      transform: `translateX(-${shifterRect.width * currentSlide}px)`
    });
  }, [shifterRef, setSliderTranslateX, currentSlide]);

  const navigateLeft = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const navigateRight = () => {
    if (currentSlide < 4) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => navigateRight(),
    onSwipedRight: () => navigateLeft()
  });

  useEffect(() => adjustSlider(), [currentSlide]);
  useEffect(() => {
    window.addEventListener('resize', adjustSlider);
    return () => window.removeEventListener('resize', adjustSlider);
  }, [adjustSlider]);

  return (
    <section id='checklist' className='s-checklist'>
      <div className='container'>
        <div className='s-checklist__text'>
          <h2 className='u-text-purple'>Deine Checkliste zur Teilnahme:</h2>
        </div>

        <div className='s-checklist__slider' {...swipeHandlers}>
          <div className='s-checklist__slider-shifter' style={shifterTranslateX} ref={shifterRef}>
            <div className='s-checklist__slide-wrapper'>
              <div className='s-checklist__slide'>
                <CheckWithCircle />
                <p>
                  Du bist zwischen
                  <br />
                  18 und 29 Jahre alt?
                </p>
              </div>
            </div>
            <div className='s-checklist__slide-wrapper'>
              <div className='s-checklist__slide'>
                <CheckWithCircle />
                <p>
                  Du hast eine Idee für Deine Region, mit der Du tolle neue Möglichkeiten für viele
                  Personen schaffst?
                </p>
              </div>
            </div>
            <div className='s-checklist__slide-wrapper'>
              <div className='s-checklist__slide'>
                <CheckWithCircle />
                <p>
                  Du hältst die geplanten Kosten möglichst klein, damit Deine Idee realisiert werden
                  kann?
                </p>
              </div>
            </div>
            <div className='s-checklist__slide-wrapper'>
              <div className='s-checklist__slide'>
                <CheckWithCircle />
                <p>Deine Idee ist gut durchdacht und auf Langlebigkeit ausgelegt?</p>
              </div>
            </div>
            <div className='s-checklist__slide-wrapper'>
              <Link className='s-checklist__slide s-checklist__slide--last' to='/mitmachen'>
                <span>
                  <ChevronThiccRight />
                </span>
                <p>
                  Dann reiche Deine Idee
                  {' '}
                  <br />
                  jetzt gleich ein!
                </p>
              </Link>
            </div>
          </div>

          <div className='s-checklist__slider-controls'>
            <button
              className='s-checklist__control s-checklist__control--left'
              disabled={currentSlide === 0}
              onClick={navigateLeft}
            >
              <ChevronLeft />
            </button>
            <div className='s-checklist__dots'>
              <div className={`s-checklist__dot ${currentSlide === 0 ? 'active' : ''}`}></div>
              <div className={`s-checklist__dot ${currentSlide === 1 ? 'active' : ''}`}></div>
              <div className={`s-checklist__dot ${currentSlide === 2 ? 'active' : ''}`}></div>
              <div className={`s-checklist__dot ${currentSlide === 3 ? 'active' : ''}`}></div>
              <div className={`s-checklist__dot ${currentSlide === 4 ? 'active' : ''}`}></div>
            </div>
            <button
              className='s-checklist__control s-checklist__control--right'
              disabled={currentSlide === 4}
              onClick={navigateRight}
            >
              <ChevronRight />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Checklist;
